import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css'; 

import WorkIcon from '@mui/icons-material/Work';
import SchoolIcon from '@mui/icons-material/School';
import StarIcon from '@mui/icons-material/Star';    

export default function Experience() {
      return (
      <div className="App-exp">
        <h1>Work Experience</h1>
        <VerticalTimeline>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'rgb(31 79 118)', color: '#fff' }}
            contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
            date="Jun 2022 – Mar 2026"
            iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
            icon={<WorkIcon />}
          >
            <h3 className="vertical-timeline-element-title">IT Project Manager</h3>
            <h4 className="vertical-timeline-element-subtitle">Company Name: Peoples Group | Canadian Banking & Fintech Solutions
</h4>
            <p>
              Project management and team leadership
            </p>
            <p>
              IT project management, project charters, project planning, budgeting, infrastructure, and security
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'rgb(31 79 118)', color: '#fff' }}
            contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
            date="Feb 2021 – Apr 2022"
            iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
            icon={<WorkIcon />}
          >
            <h3 className="vertical-timeline-element-title">Assistant Manager</h3>
            <h4 className="vertical-timeline-element-subtitle">Company Name: PCCW (OTT | viu.com)</h4>
            <p>
              Development, Project management and team leadership
            </p>
            <p>
              Payment channel integration, backend integration projects with the India product team, and internal system refactoring
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'rgb(31 79 118)', color: '#fff' }}
            contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
            date="Feb 2019 – Feb 2021"
            iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
            icon={<WorkIcon />}
          >
            <h3 className="vertical-timeline-element-title">Senior Project Officer</h3>
            <h6 className="vertical-timeline-element-subtitle">Company Name: PCCW (OTT | viu.com)</h6>
            <p>
              Development, Project Management
            </p>
            <p>
              Payment integrations with third-party partners across Thailand, Singapore, the Philippines, and Hong Kong
            </p>
          </VerticalTimelineElement> 

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'rgb(31 79 118)', color: '#fff' }}
            contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
            date="Mar 2017 – Feb 2019"
            iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
            icon={<WorkIcon />}
          >
            <h3 className="vertical-timeline-element-title">Web Developer</h3>
            <h4 className="vertical-timeline-element-subtitle">Company Name: PCCW (Media | now.com)</h4>
            <p>
              API development in PHP
            </p>
            <p>
              Mobile app development in iOS and Objective-C 
            </p>
            <p>
              <a className="linkColor" href="https://finance.now.com">https://finance.now.com</a> 
            </p>
            <p>
              <a className="linkColor" href="https://news.now.com">https://news.now.com</a> 
            </p>
          </VerticalTimelineElement> 

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'rgb(31 79 118)', color: '#fff' }}
            contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
            date="Mar 2016 – Feb 2017"
            iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
            icon={<WorkIcon />}
          >
            <h3 className="vertical-timeline-element-title">Assistant Technical Officer</h3>
            <h4 className="vertical-timeline-element-subtitle">Company Name: Hong Kong Polytechnic University</h4>
            <p>
              Server and infrastructure management.
            </p>
            <p>
              Technical support
            </p>
            <p>
              System design and implementation
            </p>
          </VerticalTimelineElement> 

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'rgb(31 79 118)', color: '#fff' }}
            contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
            date="Aug 2014 – Mar 2016"
            iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
            icon={<WorkIcon />}
          >
            <h3 className="vertical-timeline-element-title">Senior Web Developer</h3>
            <h4 className="vertical-timeline-element-subtitle">Company Name: AsOne Interactive (Social Media)</h4>
            <p>
              Facebook application development
            </p>
            <p>
              Instagram API and WeChat application integration
            </p>
            <p>
              Digital marketing projects in collaboration with internal designers
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'rgb(31 79 118)', color: '#fff' }}
            contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
            date="Nov 2013 – Aug 2014"
            iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
            icon={<WorkIcon />}
          >
            <h3 className="vertical-timeline-element-title">Web Developer</h3>
            <h4 className="vertical-timeline-element-subtitle">Company Name: Splash Interactive </h4>
            <p>
              Collaborated with the marketing team to develop online and social media campaigns
            </p>
            <p>
              Website development
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
              iconStyle={{ background: 'rgb(16, 204, 82)', color: '#fff' }}
              icon={<StarIcon />}
            />
        </VerticalTimeline>
        {/*<div className="gallery">
          <PhotoAlbum onClick={ClickHandler} layout="masonry" photos={photos} />
        </div>*/}
      </div>
      );
}